import { LoginInput } from "@graphql";

const init = (): LoginInput => ({
  email: "",
  password: "",
});

export default init;
